import { FlexBox, Spinner } from '@dixa/lib-shared-habla';

import { authApi } from 'apis/auth';
import { useAppPathParams } from 'utils/url/useAppPathParams';

import { ViewToken } from './components/viewToken/viewToken';

export const pathToApiTokensSettings = '/settings/integrations/api-tokens';

/** Page to show details for an API token. */
export const SettingsIntegrationsApiTokensTokenView = (): JSX.Element => {
  const params = useAppPathParams('/settings/integrations/api-tokens/:id');

  const { token, isLoading } = authApi.useReadApiTokensQuery(undefined, {
    selectFromResult: ({ data, ...rest }) => ({
      ...rest,
      token: data?.data.tokens.find((token) => token.id === params.id),
    }),
  });

  return (
    <>
      {isLoading ? (
        <FlexBox height="100%" alignItems="center" justifyContent="center">
          <Spinner />
        </FlexBox>
      ) : (
        <ViewToken token={token} />
      )}
    </>
  );
};
